module.exports = __webpack_public_path__ + "static/img/img_iot_al_lk.a0fd6492.png";